<template>
  <el-checkbox
   v-if="!checkBoxList"
   v-model="checkValue"
   @change="change"
   >
    <slot></slot>
  </el-checkbox>

  <el-checkbox-group
   v-model="check" 
   v-else>
    <el-checkbox 
     v-for="(i,v) in checkBoxList" 
     :label="v.label" 
     :disabled="v.disabled" 
     :key="i"></el-checkbox>
  </el-checkbox-group>
</template>
<script>
import {
  CheckboxGroup,
  Checkbox
} from 'element-ui'
export default {
  name:'checkBox',
  props:{
    value:{
      type:[Array,Boolean]
    },
    checkBoxList:{
      type:Array
    }
  },
  data(){
    return {

    }
  },
  methods:{
    change(v){
      this.$emit('change',v)
    }
  },
  computed:{
    checkValue:{
      get(){
        return this.value;
      },
      set(v){
        this.$emit('input',v)
      }
    }
  },
  components:{
    elCheckboxGroup:CheckboxGroup,
    elCheckbox:Checkbox
  }
}
</script>


// WEBPACK FOOTER //
// src/components/checkBox.vue